import React from 'react';
import BookingCategoryGroup from './BookingCategoryGroup.js';

function BookingCategoryGroupSelection(props) {

    function getCategoryData() {
        return props.customerData.categories;
    }

    const uniqueGroups = [...new Set(getCategoryData().map(group => group.OnlineTypeGroup))];
    const groups = uniqueGroups.map((group) => {
        if (group)
            return (
                <BookingCategoryGroup key={group} customerData={props.customerData} onSelect={props.onSelect} groupName={group}></BookingCategoryGroup>
            )
        else
            return <React.Fragment key={group}></React.Fragment>;
    });

    return (
        <React.Fragment>
            <BookingCategoryGroup customerData={props.customerData} onSelect={props.onSelect} groupName='Missing-group'></BookingCategoryGroup>
            {groups}
        </React.Fragment>
    );

}

export default BookingCategoryGroupSelection;